// 부대시설
export const AMENITIES_LIST = [
  { id: 'AMENITIES0', data: '전기' },
  { id: 'AMENITIES1', data: '인터넷' },
  { id: 'AMENITIES2', data: '화장실' },
  { id: 'AMENITIES3', data: '샤워실' },
  { id: 'AMENITIES4', data: '온수사용' },
  { id: 'AMENITIES5', data: '개수대' },
  { id: 'AMENITIES6', data: '매점' },
  { id: 'AMENITIES7', data: '화로/바베큐' },
  { id: 'AMENITIES8', data: '공용주차장' },
  { id: 'AMENITIES9', data: '까페' },
];

// 자연환경
export const ENV_LIST = [
  { id: 'ENV0', data: '바다' },
  { id: 'ENV1', data: '계곡' },
  { id: 'ENV2', data: '강/호수' },
  { id: 'ENV3', data: '섬' },
  { id: 'ENV4', data: '도심' },
  { id: 'ENV5', data: '산/숲' },
];

// 테마
export const THEME_LIST = [
  { id: 'THEME0', data: '연인' },
  { id: 'THEME1', data: '가족' },
  { id: 'THEME2', data: '럭셔리' },
  { id: 'THEME3', data: '파티' },
  { id: 'THEME4', data: '당일피크닉' },
  { id: 'THEME5', data: 'TV에서 봤어요' },
  { id: 'THEME6', data: '독채' },
  { id: 'THEME7', data: '반려동물' },
  { id: 'THEME8', data: '차박가능' },
];

// 숙소유형
export const TYPE_LIST = [
  { id: 'TYPE0', data: '캠핑' },
  { id: 'TYPE1', data: '이지캠핑' },
  { id: 'TYPE2', data: '글램핑' },
  { id: 'TYPE3', data: '카라반' },
  { id: 'TYPE4', data: '방갈로' },
  { id: 'TYPE5', data: '게스트하우스' },
  { id: 'TYPE6', data: '펜션' },
  { id: 'TYPE7', data: '일반야영장' },
  { id: 'TYPE8', data: '자동차야영장' },
  { id: 'TYPE9', data: '기타' },
];

// 지역
export const LOCATION_LIST = [
  { id: 'LOCATION0', data: '경기도' },
  { id: 'LOCATION1', data: '강원도' },
  { id: 'LOCATION2', data: '충청북도' },
  { id: 'LOCATION3', data: '충청남도' },
  { id: 'LOCATION4', data: '경상북도' },
  { id: 'LOCATION5', data: '경상남도' },
  { id: 'LOCATION6', data: '전라북도' },
  { id: 'LOCATION7', data: '전라남도' },
  { id: 'LOCATION8', data: '서울' },
  { id: 'LOCATION9', data: '인천' },
  { id: 'LOCATION10', data: '대전' },
  { id: 'LOCATION11', data: '광주' },
  { id: 'LOCATION12', data: '대구' },
  { id: 'LOCATION13', data: '울산' },
  { id: 'LOCATION14', data: '부산' },
  { id: 'LOCATION15', data: '제주' },
];
